"use client"

// /src/components/common/Report.js
import { useEffect, useState, useContext, useRef } from "react"
import { useNavigate } from "react-router-dom"
import PatientContext from "../../../context/PatientContext"
import Cookies from "js-cookie"
import AICVDPatientReport from "../../Reports/AICVDReport"
import PrediabetesPatientReport from "../../Reports/PrediabetesReportPage"
import LiverReport from "../../Reports/LiverReport"
import OuterFrame from "../OuterFrame"
import "./index.css"
import { ColorRing } from "react-loader-spinner"
import COPDComponent from "../../Reports/COPDReport"
import CKDomponent from "../../Reports/CKDReport"
import HypertensionReport from "../../Reports/HypertensionReport"

const Report = (props) => {
  const navigate = useNavigate()
  const [patientReport, setPatientReport] = useState("")
  const [current_app, setApp] = useState(props.app)
  const { setContextPatientReport } = useContext(PatientContext)
  const hasFetched = useRef(false)
  const lastFetchKey = useRef("")

  useEffect(() => {
    const fetchData = async () => {
      const url = props.REPORT_URL
      const jwt_token = Cookies.get("jwt_token")
      const formDetailsString = JSON.stringify(props.formDetails)

      const fetchKey = `${url}-${formDetailsString}`

      if (hasFetched.current && lastFetchKey.current === fetchKey) {
        return
      }

      hasFetched.current = true
      lastFetchKey.current = fetchKey

      const myHeaders = new Headers()
      myHeaders.append("Content-Type", "application/json")
      myHeaders.append("Authorization", `Bearer ${jwt_token}`)
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: myHeaders,
          body: formDetailsString,
        })

        const responseObj = await response.json()
        if (response.ok) {
          setPatientReport(responseObj)
          setContextPatientReport(responseObj)
        } else {
          alert("Failed to fetch the data")
          hasFetched.current = false
        }
      } catch (error) {
        console.error("Error fetching data:", error)
        hasFetched.current = false
      }
    }

    fetchData()
    setApp(props.app)
  }, [props.REPORT_URL, props.app, props.formDetails, setContextPatientReport])

  const handleGeneratePdf = () => {
    const app = current_app === "aicopd" ? "copd" : current_app === "aickd" ? "ckd" : current_app
    navigate(`/${app}/pdfreport`)
  }

  return (
    <OuterFrame
      appName={
        props.app && props.app === "prediabetes"
          ? "PREDIABETES AI REPORT"
          : props.app === "aicvd"
            ? "AICVD REPORT"
            : props.app === "liver"
              ? "AILF REPORT"
              : props.app === "aicopd"
                ? "AICOPD REPORT"
                : props.app === "hypertension"
                  ? "AI HYPERTENSION  REPORT"
                  : props.app === "aickd"
                    ? "AICKD REPORT"
                    : null
      }
      doc_name={
        props.app === "prediabetes"
          ? "prediabetes"
          : props.app === "aicvd"
            ? "aicvd"
            : props.app === "liver"
              ? "ailf"
              : props.app === "aicopd"
                ? "aicopd"
                : props.app === "hypertension"
                  ? "hypertension"
                  : props.app === "ckd"
                    ? "ckd"
                    : null
      }
      hightlight="3"
      color={props.color}
      secondaryColor={props.secondaryColor}
      surface_color={props.surface_color}
      surface_highlight_color={props.surface_highlight_color}
      surface_hover_color={props.surface_hover_color}
      button_hover_color={props.button_hover_color}
      component={
        <div className="container-div">
          {patientReport !== "" ? (
            <div className="report-form-page-conatiner">
              {props.app === "aicvd" ? (
                <AICVDPatientReport data={patientReport} />
              ) : props.app === "prediabetes" ? (
                <PrediabetesPatientReport data={patientReport} />
              ) : props.app === "liver" ? (
                <LiverReport data={patientReport} />
              ) : props.app === "aicopd" ? (
                <COPDComponent data={patientReport} />
              ) : props.app === "aickd" ? (
                <CKDomponent data={patientReport} />
              ) : props.app === "hypertension" ? (
                <HypertensionReport data={patientReport} />
              ) : null}

              <div className="submit-button-container">
                <button type="submit" className="submit-button" onClick={handleGeneratePdf}>
                  View PDF
                </button>
              </div>
            </div>
          ) : (
            <div className="app-loading-container">
              <div className="login-loader-container">
                <ColorRing
                  height="80"
                  width="80"
                  ariaLabel="bars-loading"
                  visible={true}
                  colors={["#a09be4", "#a09be4", "#a09be4", "#a09be4", "#a09be4"]}
                />
              </div>
            </div>
          )}
        </div>
      }
    />
  )
}

export default Report
